import { openFailToSavedModal } from '@/corePagesModule/components/modal/modalActions';
import axios from 'axios';

axios.interceptors.response.use((response) => {
  // 成功時はそのまま返す
  switch (response.status) {
    case 404:
      openFailToSavedModal();
    default:
      return response;
  }
});
